import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import {PageScrollConfig} from 'ngx-page-scroll';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  _router: any;
  private fragment: string;

  constructor( private meta: Meta ) {
    this.meta.addTag({
      name: 'description', content: 'CyM consultores tus aliados en los negocios."'
    });
      this.meta.addTag({
        name: 'author', content: 'Claudio Salazar - www.claudiosalazar.cl'
    });
    this.meta.addTag({
      name: 'keywords', content: 'Consultores financieros, Asesoria tributaria, Asesoria contable, Asesoria laboral, contabilidad'
    });
    this.meta.addTag({
      name: 'robots', content: 'index, follow'
    });

    PageScrollConfig.defaultScrollOffset = 20;
    PageScrollConfig.defaultEasingLogic = {
      ease: (t: number, b: number, c: number, d: number): number => {
        if (t === 0) { return b; }
        if (t === d) { return b + c; }
        if ((t /= d / 2) < 1) { return c / 2 * Math.pow(2, 10 * (t - 1)) + b; }
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
      }
    };
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/inicio/inicio.component.ts